import React from 'react';
import { ROUTER_LINKS } from '../../../consts/app-keys.const';
import { GearIcon, KeyIcon, LogoutIcon } from '../../icons';
import { Logout } from '../../../../settings/popups';

interface IHeaderData {
  text: string;
  to: string;
  icon: () => React.ReactNode;
  popup?: ({
    isOpen,
    onClose
  }: {
    isOpen: boolean;
    onClose: () => void;
  }) => React.ReactNode;
}

const AdminIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const baseItems: IHeaderData[] = [
  {
    text: 'My Products',
    to: ROUTER_LINKS.MANAGEMENT,
    icon: KeyIcon
  },
  {
    text: 'Settings',
    to: ROUTER_LINKS.SETTINGS,
    icon: GearIcon
  },
  {
    text: 'Log out',
    to: '',
    icon: LogoutIcon,
    popup: Logout
  }
];

const adminItem: IHeaderData = {
  text: 'Admin',
  to: ROUTER_LINKS.ADMIN,
  icon: AdminIcon
};

export const getHeadersData = (isAdmin: boolean): IHeaderData[] =>
  isAdmin ? [adminItem, ...baseItems] : baseItems;
